var _rect, _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGooglePlay({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 228,
    height: 65,
    viewBox: "0 0 228 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1.05127,
    width: 225.73,
    height: 62.843,
    rx: 16,
    fill: "white",
    stroke: "#090909",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_2097_3461)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.3274 11.6201C23.8448 12.1329 23.5596 12.9287 23.5596 13.9593V50.7801C23.5596 51.8123 23.8448 52.6064 24.3274 53.1192C24.3954 53.1856 24.5042 53.1849 24.5712 53.1176L44.8248 32.7849C44.9346 32.6747 44.9963 32.5253 44.9963 32.3697C44.9963 32.214 44.9346 32.0647 44.8248 31.9544L24.572 11.6209C24.5047 11.5533 24.3953 11.5529 24.3274 11.6201Z",
    fill: "url(#paint0_linear_2097_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9996 39.4033C51.9074 39.4545 51.7923 39.4382 51.7179 39.3635L45.1676 32.7844C45.0578 32.6741 44.9961 32.5248 44.9961 32.3691C44.9961 32.2134 45.0578 32.0641 45.1676 31.9538L51.72 25.3759C51.794 25.3016 51.9086 25.2862 51.9996 25.3382L60.1143 29.9666C62.4311 31.2886 62.4311 33.4513 60.1143 34.7749L51.9996 39.4033Z",
    fill: "url(#paint1_linear_2097_3461)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_2097_3461)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.1233 42.1837C49.5808 40.7818 50.0346 37.4278 48.0379 35.4232C46.3595 33.7383 43.6313 33.7384 41.953 35.4234L26.9625 50.4736C25.4935 51.9484 25.9654 54.2516 27.7743 53.2217L47.1233 42.1837Z",
    fill: "url(#paint2_linear_2097_3461)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M48.0395 29.3153C50.0355 27.3105 49.5814 23.957 47.124 22.5553L27.7743 11.5183C25.966 10.4867 25.4938 12.7917 26.963 14.2666L41.9539 29.316C43.6325 31.0012 46.3612 31.0009 48.0395 29.3153Z",
    fill: "url(#paint3_linear_2097_3461)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M113.961 26.4897C110.277 26.4897 107.275 29.2905 107.275 33.148C107.275 36.9819 110.277 39.8062 113.961 39.8062C117.647 39.8062 120.65 36.9819 120.65 33.148C120.648 29.2905 117.645 26.4897 113.961 26.4897ZM113.961 37.1855C111.942 37.1855 110.202 35.5213 110.202 33.1495C110.202 30.7527 111.944 29.1136 113.961 29.1136C115.98 29.1136 117.721 30.7527 117.721 33.1495C117.721 35.5197 115.98 37.1855 113.961 37.1855ZM99.3727 26.4897C95.6887 26.4897 92.6861 29.2905 92.6861 33.148C92.6861 36.9819 95.6887 39.8062 99.3727 39.8062C103.058 39.8062 106.061 36.9819 106.061 33.148C106.061 29.2905 103.058 26.4897 99.3727 26.4897ZM99.3727 37.1855C97.3537 37.1855 95.6135 35.5213 95.6135 33.1495C95.6135 30.7527 97.3553 29.1136 99.3727 29.1136C101.392 29.1136 103.132 30.7527 103.132 33.1495C103.133 35.5197 101.392 37.1855 99.3727 37.1855ZM83.4329 28.5341C82.6531 28.5342 82.0209 29.1665 82.0209 29.9463C82.0209 30.7263 82.6532 31.3586 83.4332 31.3586H85.1885C87.0965 31.3586 88.7221 33.2055 87.483 34.6563C87.4065 34.7459 87.327 34.8317 87.2446 34.9139C86.261 35.897 84.7213 36.9819 82.0209 36.9819C77.8577 36.9819 74.6028 33.627 74.6028 29.4658C74.6028 25.3046 77.8577 21.9497 82.0209 21.9497C83.6631 21.9497 84.9813 22.4217 86.0446 23.1191C86.6832 23.5379 87.5465 23.5391 88.0867 22.9992C88.6488 22.4374 88.6442 21.513 88.0044 21.0415C86.4664 19.9081 84.532 19.1255 82.0209 19.1255C76.318 19.1255 71.5234 23.7657 71.5234 29.4658C71.5234 35.1659 76.318 39.8062 82.0209 39.8062C85.0988 39.8062 87.4216 38.7964 89.237 36.9052C91.1041 35.0391 91.6852 32.4153 91.6852 30.2971C91.6852 29.2654 90.7913 28.5329 89.7595 28.5331L83.4329 28.5341ZM152.988 30.7276C152.434 29.2404 150.742 26.4897 147.285 26.4897C143.853 26.4897 141.001 29.1887 141.001 33.148C141.001 36.8802 143.828 39.8062 147.612 39.8062C149.797 39.8062 151.324 38.8501 152.284 37.9087C152.825 37.3776 152.651 36.5127 152.02 36.0919C151.396 35.6761 150.573 35.8697 149.995 36.3475C149.362 36.8715 148.584 37.1823 147.612 37.1823C145.437 37.1823 146.102 34.4536 148.112 33.6226L152.539 31.7928C152.955 31.6207 153.155 31.1457 152.988 30.7276ZM147.454 31.4741C145.74 32.1853 143.996 30.6844 145.542 29.658C146.137 29.2626 146.806 29.0635 147.387 29.0635C147.527 29.0635 147.664 29.0719 147.798 29.0882C149.233 29.2629 148.789 30.92 147.454 31.4741ZM136.662 37.9409C136.662 38.7488 137.317 39.4038 138.125 39.4038C138.933 39.4038 139.588 38.7488 139.588 37.9409V21.2961C139.588 20.4881 138.933 19.8331 138.125 19.8331C137.317 19.8331 136.662 20.4881 136.662 21.2961V37.9409ZM131.866 27.9102C131.866 27.948 131.836 27.9786 131.798 27.9786C131.778 27.9786 131.759 27.9697 131.745 27.9544C131.083 27.1813 129.831 26.4897 128.259 26.4897C124.927 26.4897 121.875 29.4157 121.875 33.1746C121.875 36.9068 124.927 39.8077 128.259 39.8077C129.832 39.8077 131.084 39.1161 131.745 38.3202C131.759 38.3045 131.778 38.2954 131.798 38.2954C131.836 38.2954 131.866 38.3258 131.866 38.3634V39.2535C131.866 41.8007 130.503 43.1627 128.309 43.1627C127.152 43.1627 126.279 42.6267 125.683 41.9547C125.178 41.3844 124.383 41.0294 123.679 41.322C122.975 41.615 122.633 42.4335 123.07 43.0585C124.061 44.4727 125.795 45.7865 128.309 45.7865C131.741 45.7865 134.643 43.7685 134.643 38.8496V28.284C134.643 27.517 134.021 26.8952 133.254 26.8952H132.409C132.11 26.8952 131.867 27.1376 131.867 27.4369L131.866 27.9102ZM128.511 37.1855C126.492 37.1855 124.802 35.4947 124.802 33.1746C124.802 30.8278 126.492 29.1136 128.511 29.1136C130.503 29.1136 132.068 30.8278 132.068 33.1746C132.068 35.4947 130.503 37.1855 128.511 37.1855ZM166.7 19.8331C162.832 19.8331 159.697 22.9685 159.697 26.8361V37.9432C159.697 38.7499 160.35 39.4038 161.157 39.4038C161.964 39.4038 162.618 38.7499 162.618 37.9432V35.6966C162.618 33.6492 164.278 31.9895 166.325 31.9895H166.698C169.937 31.9895 173.123 29.6459 173.123 25.9121C173.123 22.1783 169.939 19.8331 166.7 19.8331ZM166.775 29.2654H165.972C164.119 29.2654 162.618 27.7637 162.618 25.9113C162.618 24.0588 164.119 22.5571 165.972 22.5571H166.775C168.96 22.5571 170.2 24.3653 170.2 25.9121C170.2 27.4275 168.96 29.2654 166.775 29.2654ZM184.838 26.4553C183.201 26.4553 181.519 27.0126 180.422 28.2206C179.877 28.8196 180.236 29.7074 180.983 30.0189C181.68 30.3094 182.463 29.955 183.1 29.5512C183.619 29.2229 184.245 29.0979 184.888 29.0979C186.399 29.0979 187.936 30.0044 187.961 31.6153C187.961 31.7053 187.863 31.7626 187.783 31.7221C187.201 31.4286 186.158 31.0627 184.913 31.0627C182.117 31.0627 179.269 32.5985 179.269 35.4681C179.269 38.0872 181.562 39.7733 184.131 39.7733C186.077 39.7733 187.159 38.9085 187.84 37.8879C187.852 37.8696 187.872 37.8586 187.894 37.8586C187.93 37.8586 187.959 37.8878 187.959 37.9238V38.614C187.959 39.0312 188.298 39.3694 188.715 39.3694H189.371C190.15 39.3694 190.782 38.7375 190.782 37.9581V31.8658C190.783 28.3934 188.186 26.4553 184.838 26.4553ZM184.484 37.1808C183.528 37.1808 182.192 36.7017 182.192 35.5182C182.192 34.0074 183.856 33.4282 185.292 33.4282C186.953 33.4282 187.931 35.415 186.62 36.4357C186.014 36.9078 185.262 37.1808 184.484 37.1808ZM202.062 26.8827C201.457 26.8827 200.914 27.2523 200.692 27.8147L197.728 35.3209C197.717 35.3493 197.69 35.3679 197.659 35.3679C197.629 35.3679 197.602 35.3497 197.591 35.3218L194.496 27.7699C194.276 27.2332 193.753 26.8827 193.173 26.8827C192.142 26.8827 191.45 27.9426 191.865 28.887L195.548 37.2618C195.962 38.2038 195.957 39.2772 195.534 40.2154L194.105 43.3865C193.692 44.3022 194.362 45.3388 195.367 45.3388C195.917 45.3388 196.416 45.0123 196.635 44.5074L203.413 28.9438C203.836 27.9709 203.123 26.8827 202.062 26.8827ZM174.736 37.9432C174.736 38.7499 175.39 39.4038 176.197 39.4038C177.004 39.4038 177.658 38.7499 177.658 37.9432V21.2937C177.658 20.487 177.004 19.8331 176.197 19.8331C175.39 19.8331 174.736 20.487 174.736 21.2937V37.9432Z",
    fill: "#090909"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_2097_3461",
    x: 23.5596,
    y: 11.261,
    width: 38.292,
    height: 42.2175,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.795
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2097_3461"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.795
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2097_3461",
    result: "effect2_innerShadow_2097_3461"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_2097_3461",
    x: 26.0928,
    y: 34.1597,
    width: 23.1973,
    height: 19.3188,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.795
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2097_3461"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2097_3461",
    x1: 43.175,
    y1: 13.5697,
    x2: 15.235,
    y2: 41.4011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2097_3461",
    x1: 63.1301,
    y1: 32.3691,
    x2: 23.0031,
    y2: 32.3691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2097_3461",
    x1: 48.1963,
    y1: 36.188,
    x2: 10.3061,
    y2: 73.9309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2097_3461",
    x1: 19.123,
    y1: -0.635792,
    x2: 36.042,
    y2: 16.2175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/Google_Play.1433d24355a08277daee3fb7121e5ffc.svg";
export { ForwardRef as ReactComponent };